<div class="row mt-5">
  <div class="col-12 col-lg-8 col-xl-6 mx-auto d-flex flex-column">
    <h1 class="title-font text-center mb-5">Je suis...</h1>
    <div class="row justify-content-center align-items-stretch" id="main-section">
      <div class="col-lg-4 col-12">
        <div class="card connexion-item box-shadow p-3 align-items-stretch h-100">
          <h3 class="title-font text-center">Un professionnel de l'insertion</h3>
          <p>Je me connecte avec</p>
          <div class="logo">
            <img src="../../assets/pc.svg" alt="Pro Connect" />
          </div>
          <button class="btn btn-primary mt-auto" (click)="pcLogin()" aria-label="Inclusion Connect">Connexion Pro Connect</button>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="card connexion-item box-shadow p-3 align-items-stretch h-100">
          <h3 class="title-font text-center">Un agent de la Métropole de Lyon</h3>
          <p>Je me connecte avec</p>
          <div class="logo">
            <img src="../../assets/sng-connect.png" alt="Sign&Go" />
          </div>
          <button class="btn btn-primary mt-auto" (click)="sngLogin()" aria-label="Sign&Go">Connexion Sign&Go</button>
        </div>
      </div>
    </div>
    @if (hasLoginFailed === 403) {
      <ngb-alert class="col mt-2" type="danger">Compte désactivé, contactez votre administrateur.</ngb-alert>
    }
    @if (maintenanceMode) {
      <ngb-alert class="col mt-2" type="danger" [dismissible]="false"
        >Insertis est en cours de maintenance, merci de réessayer ultérieurement.</ngb-alert
        >
      }
      <div class="row mt-4">
        <div class="col-12">
          <a href="assets/INSERTIS-FEDER.pdf" target="_blank">
            <img class="w-100" src="assets/Europe-FEDER.png" alt="Union Européenne et l'Europe s'engage en région Auvergne-Rhône-Alpes avec le FEDER" />
          </a>
        </div>
      </div>
    </div>
  </div>
